import {mapGetters,mapActions,mapMutations} from "vuex";
import api from "../api";
import router from "../router";
import UtilityMixin from "./globalUtilityMixin";

export default {
    mixins: [UtilityMixin],
    props: {
        id: String
    },
    data() {
        return {
            model: {},
            isLoading: true,
            service:{},
            platformCategory: undefined,
            platformCategoryName: undefined
        };
    },
    created() {
        this.isLoading = true;
        this.fetchPlatformCategories();
        this.getPage(this.$route.params.id);
    },
    computed: {
        ...mapGetters(["authResponse","platformCategories"]),
        isModelFullPage() {
            return this.model.fullPage;
        },
        loading() {
            return this.isLoading;
        },
        checkStaticPage() {
            return this.model.contentType === "STATIC";
        },

    },
    mounted() {},
    methods: {
        loaded(instance) {},
        ...mapActions(["fetchPlatformCategories"]),
        ...mapMutations(["setContentPageModel","setPlatformCategory","setPlatformCategoryName","setContentPageNavigationText","setService"]),
        getPage: function(id) {
            this.isLoading = true;
            api
                .getPage(id)
                .then(response => {
                    this.model = response.data;
                    document.title = `${this.model.title} - Autodesk One`;
                    api.getService(response.data.serviceSysId).then((serviceResponse) => {
                        this.service = serviceResponse.data;
                        this.setService(serviceResponse.data)
                        this.platformCategory = serviceResponse.data.platformCategory;
                        if (this.platformCategories && this.platformCategories.length > 0) {
                            this.platformCategories.forEach(category => {
                                if(category.alias == this.platformCategory){
                                    this.platformCategoryName = category.name;
                                }
                            });
                        }
                        this.setContentPageModel(this.model)
                        this.setPlatformCategory(this.platformCategory)
                        this.setPlatformCategoryName(this.platformCategoryName)
                        this.updateNavigationText()
                        this.$hhMixpanel.trackEvent(`Autodesk One - Knowledge Base - `, {
                            subEvent: response.data.title
                        });
                        this.scrollToAnchor();
                    }).catch(error => {
                        router.push({ name: "page-not-found" });
                    }).finally(() => {
                        this.isLoading = false;
                    });
                }).catch((error) => {
                    router.push({ name: "page-not-found" });
                })
        },
        updateNavigationText: function() {
            this.isOfferingPage() ? this.setContentPageNavigationText("Back to service") : this.setContentPageNavigationText("View all " + this.platformCategoryName+" articles");
        },
        isOfferingPage() {
            return this.model.offeringSysId && this.model.serviceSysId;
        },
        scrollToAnchor(){
            let that = this;
            //Scroll to hash if hash is provided in the URL.
            //Need to implement this custom logic as content is loaded via API call.
            this.$nextTick(() => {
                if (that.$route.hash) {
                    //Try with Jquery # i.e. id and then with name attribute
                    let hash = that.$route.hash;
                    that.$scrollTo(hash, 300, {
                        easing: "linear"
                    });
                    //Some knowledge articles have anchor by name instead of hash-id
                    //This patch applies a fix such that it works for all KB articles
                    let attrName = hash.replace("#", "");
                    that.$scrollTo(`a[name=${attrName}]`, 300, {
                        easing: "linear"
                    });
                }
            });
        }
    }

}